import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Routes } from "../../constants";
import { injectModels } from "../../redux/injectModels";
import CreateUser from "./CreateUser";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import UpdateUser from "./UpdateUser";
import ViewUser from "./ViewUser";

const User = (props) => {
  const [id, setId] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [showViewUser, setShowViewUser] = useState(false);
  const [showUpdateUser, setShowUpdateUser] = useState(false);

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;

  let paginatedData = [];
  try {
    if (Array.isArray(filteredData)) {
      paginatedData = filteredData.slice(offset, offset + rowsPerPage);
    } else {
      throw new Error("filteredData is not an array");
    }
  } catch (exception) {
    paginatedData = [];
    console.log(exception);
  }

  useEffect(() => {
    getUsers();
  }, [props.admin.loadingUser, props.admin.userUpdateLoading]);

  const getUsers = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getAllUsers();
      if (res) {
        setFilteredData(res.users);
      }
      props.application.setLoading(false);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      props.application.setLoading(false);
    }
  };

  const handleDeleteUser = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteUser(id);
          if (res && res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            getUsers();
          } else {
            toast.dismiss();
            toast.error(res.message || "Failed to delete user", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.error("Error deleting user:", error);
          toast.dismiss();
          toast.error("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };

  const handelViewUserOpen = (id) => {
    setShowViewUser(true);
    setId(id);
  };
  const handelViewUserClose = () => {
    setShowViewUser(false);
  };

  const handelUpdateUserOpen = (id) => {
    setShowUpdateUser(true);
    setId(id);
  };
  const handelUpdateUserClose = () => {
    setShowUpdateUser(false);
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>User Management</h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={Routes.DASHBOARD}>Home</Link>
            </li>
            <li className="breadcrumb-item active">User Management</li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <div className="d-flex justify-content-between">
                    <ul
                      className="nav nav-pills mb-3"
                      id="pills-tab"
                      role="tablist"
                    ></ul>
                    <div>
                      <a
                        href="#"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#largeModal"
                      >
                        Create User
                      </a>
                    </div>
                  </div>
                  <div className="tab-content pt-2" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Mac Address</th>
                            <th>Role</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedData && paginatedData.length > 0 ? (
                            paginatedData.map((item, index) => (
                              <tr key={index}>
                                <td>{item.username}</td>
                                <td>{item.email}</td>
                                <td>{item.mac_address}</td>
                                <td>{item.role}</td>
                                <td>
                                  <button
                                    className="btn btn-danger btn-sm m-0"
                                    onClick={() => handleDeleteUser(item.id)}
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-success btn-sm m-0"
                                    onClick={() => handelViewUserOpen(item.id)}
                                  >
                                    <i className="bi bi-eye-fill"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-primary btn-sm m-0"
                                    title="Update Session"
                                    onClick={() =>
                                      handelUpdateUserOpen(item.id)
                                    }
                                  >
                                    <i className="bi bi-pencil-fill"></i>
                                  </button>
                                  &nbsp;
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No results found!
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="table-footer">
                        <strong>Total Count: {filteredData.length}</strong>
                        {renderPagination()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CreateUser />
      {showUpdateUser && (
        <UpdateUser
          isOpen={showUpdateUser}
          id={id}
          closeModel={handelUpdateUserClose}
          props={props}
        />
      )}
      {showViewUser && (
        <ViewUser
          isOpen={showViewUser}
          id={id}
          closeModel={handelViewUserClose}
          props={props}
        />
      )}
    </main>
  );
};

export default injectModels(["admin", "application"])(User);
